import { takeEvery } from 'redux-saga/effects';

import * as base from "../BaseSagas";
import * as actions from './actions';
import * as api from 'store/api/transaction';


export function* watch() {
  yield takeEvery(actions.TRANSACTION_LIST_LOAD.START, actionTransactionLoad);
  yield takeEvery(actions.TRANSACTION_DETAIL_LOAD.START, actionTransactionDetailLoad);
}


function* actionTransactionLoad(action) {
  yield base.Request(action, api.transactionListLoad,
    {
      request: actions.transactionListLoadRequest,
      complete: actions.transactionListLoadComplete,
      error: actions.transactionListLoadError
    },
  );
}

function* actionTransactionDetailLoad(action) {
  yield base.Request(action, api.transactionDetailLoad,
    {
      request: actions.transactionDetailLoadRequest,
      complete: actions.transactionDetailLoadComplete,
      error: actions.transactionDetailLoadError
    },
  );
}
